import React from 'react'
import { Helmet } from 'react-helmet'
import Header from '../../components/Header/index'
import Footer from '../../components/Footer/index'
import MenuAside from '../../components/MenuAside/index'

import Blog from '../../components/Blog/index'

const BlogHome = () => {
  return (
    <>
      <Helmet>
        <title>Blog - oBoticario</title>
        <meta property="og:title" content="Blog - oBoticario" />
	      <meta property="og:url" content="https://emprendeoboticario.com.co/blog/" />
        <link rel="canonical" href="https://emprendeoboticario.com.co/blog/" />
      </Helmet>

      <Header page="blog" />
      <Blog />
      <Footer />
      <MenuAside />
    </>
  );
};

export default BlogHome
